<template>
  <v-container class="p-order">
    <c-section title="保全查询">
      <v-layout class="link-wrap mb-2" ref="statusList">
        <template v-for="(item,index) in statusList">
          <a
            :key="item.title"
            :class="{active:query.status === item.value}"
            class="search-status"
            @click="query.status = item.value"
          >{{ item.title }}</a>
          <div :key="index" v-if="index < statusList.length - 1" class="vertical"></div>
        </template>
      </v-layout>
      <v-layout>
        <v-flex class="form-item form-item-left">
          <label>保单号</label>
          <v-text-field
            v-model="policyCode"
            :solo="solo"
          ></v-text-field>
        </v-flex>
        <v-flex class="form-item">
          <label class="long-label">保全申请日期</label>
          <v-menu
            ref="dateMenu"
            v-model="effectBeginDateMenuVisible"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              class="date-input"
              v-model="submitTime"
              :solo="solo"
              append-icon="calendar_today"
              readonly
            ></v-text-field>
            <v-date-picker
              v-model="submitTime"
              :header-date-format="date=>date"
              no-title
              @input="effectBeginDateMenuVisible = false"
            ></v-date-picker>
          </v-menu>
          <v-btn style="margin-top:-2px" color="primary" @click="datasearch">搜索</v-btn>
        </v-flex>
      </v-layout>
      <div class="order-list" v-loading="false">
        <ListItem :order="orderList" @update="isUpdate"></ListItem>
      </div>
      <div class="text-xs-center pt-2">
        <v-pagination v-model="page.pageIndex" :length="totalPage"></v-pagination>
      </div>
    </c-section>
  </v-container>
</template>

<script>
import ListItem from "./components/ListItem";
export default {
  components: {
    ListItem
  },
  data() {
    return {
      solo:true,
      effectBeginDateMenuVisible:false,
      loading: true,
      statusList: [
        { title: "全部", value: -1 },
        { title: "已承保", value: 1 },
        { title: "未承保", value: 0 }
      ],
      query: {
        status: -1
      },
      page: {
        pageIndex: 1, // 从1开始
        pageSize: 10,
        totalSize: 0
      },
      orderList: [],
      heightTotal:0,
      policyCode:'',
      submitTime:'',
      //产品id集合
      productIds: [2016, 2017]
    };
  },
  computed: {
    totalPage() {
      if (this.page.totalSize % this.page.pageSize === 0) {
        return this.page.totalSize / this.page.pageSize;
      }
      return parseInt(this.page.totalSize / this.page.pageSize) + 1;
    }
  },
  watch: {
    "page.pageIndex"() {
      this.getData();
    },
    "query.status"() {
      this.pageIndex= 1, // 从1开始
      this.getData();
    },
    heightTotal(){
      this.page.pageIndex = this.page.pageIndex + 1;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    isUpdate(){
      this.getData()
    },
    datasearch(){
      this.page.pageIndex = 1;
      this.getData()
    },
    getData() {
      this.loading = true;
      const params = {
          policyNo:this.policyCode,
          submitTime:this.submitTime,
          pageIndex: this.page.pageIndex, // 接口是从0开始的
          pageSize: this.page.pageSize,
          ...this.query
      }
      this.$axios.post("/app/api/endorsement/list",params).then(res => {
          this.loading = false;
          let arr = res.data;
          arr.forEach(ele => {
            ele.statusTxt = ele.status == 0?'未承保':ele.status == 1?'已承保':'失败'
            ele.typeTxt = ele.typeId == 1?'增员':ele.typeId == 2?'减员':'替换'
          });
          this.orderList = arr.filter(item=>this.productIds.indexOf(Number(item.productId)) !== -1);
          this.orderList.forEach(r=>{
            let y = r.submitTime.substring(0, 4);
            let m = r.submitTime.substring(4, 6);
            let d = r.submitTime.substring(6, 8);
            r.submitTime = `${y}-${m}-${d}`
          })
          this.page.totalSize = res.total;
          // setTimeout(() => {
          //   this.$vuetify.goTo(50);
          // }, 100);
        })
        .catch(err => {
          this.loading = false;
          this.$message.error("订单查询异常：" + err);
        });
    },
  }
};
</script>

<style lang="scss" scoped>
$form-item-left-width: 294px;
$form-item-label-width: 94px;
$label-margin-right: 20px;
$input-width: $form-item-left-width - $form-item-label-width -
  $label-margin-right;
.p-order {
  .link-wrap {
    .search-status,
    .vertical {
      margin-right: 30px;
    }
    .search-status {
      color: #666666;
    }
  }
}
  .form-item {
    .long-label{
     width: 94px
    }
  }
  .form-item-left {
    width: $form-item-left-width!important;
    flex-grow: 0;
    .date-input {
      width: $input-width;
    }
  }
  .form-item-btn-mb {
    margin-bottom: 28px;
  }
  .form-item-btn-wrap {
    width: $input-width;
    .v-btn {
      margin: 0;
    }
  }
</style>

